<template>
  <div class="contents">
    <div class="tablist">
      <div
        class="hao"
        :class="[{ activeSubsidy: activeName == item.name }]"
        v-for="item in buyNjList"
        :key="item.id"
        @click="rangeClick(item)"
      >
        <!-- <img :src="item.img" alt="" /> -->
        <span>{{ item.name }}</span>
      </div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      buyNjList: [
        {
          id: 1,
          name: "补贴机具监管"
        },
        {
          id: 2,
          name: "跨区机具监管"
        },
        {
          id: 3,
          name: "预警机具监管"
        },
        // {
        //   id: 4,
        //   name: "购置与应用补贴机具监管"
        // }
        // {
        //   id: 4,
        //   name: "补贴机具审核"
        // }
      ],
      activeName: ""
    };
  },
  mounted() {
    if (window.location.pathname === "/view/DiscountSubsidys") {
      this.activeName = "补贴机具监管";
    } else if (window.location.pathname === "/view/SpanningAreaSubsidy") {
      this.activeName = "跨区机具监管";
    } else if (window.location.pathname === "/view/WarningSubsidy") {
      this.activeName = "预警机具监管";
    } else if (window.location.pathname === "/view/Monitor") {
      this.activeName = "补贴机具审核";
    }
  },
  methods: {
    rangeClick(item) {
      sessionStorage.removeItem('manageParams1')
      // this.activeName = item.name
      this.$store.commit('discountData', [])
      this.$store.commit('SpanningAreaData', [])
      this.$store.commit('WarningData', [])
      if (item.id === 1) {
        this.$router.push("/DiscountSubsidys");
      } else if (item.id === 2) {
        this.$router.push("/SpanningAreaSubsidy");
      } else if (item.id === 3) {
        this.$router.push("/WarningSubsidy");
      } else if (item.id === 4) {
        this.$router.push("/Monitor");
      } else if (item.id === 5) {
        this.$router.push("/Satellite");
        // this.$router.push("/MachMonitor")
      }
    }
  }
};
</script>
<style scoped>
.contents {
  width: 100%;
}
.tablist {
  width: 100%;
  height: 4.44vh;
  display: flex;
  align-items: center;
  background-image: url("/static/img/nav-bg1.png");
  background-size: 100% 100%;
	position: relative;
}
.hao {
  padding: 0 43px;
  font-size: 16px;
  padding-left: 60px;
  color: #358bff;
  text-align: center;
  border-right: solid 1px #358bff;
  cursor: pointer;
}
.tablist .hao:first-child {
  background: url('../../../static/img/nongji.png') no-repeat 15% center;
  background-size: 23px;
}
.tablist .hao:first-child.activeSubsidy {
  background: url('../../../static/img/daikuantiexi-lan.png')no-repeat 15% center;
  background-size: 18px;
}
.tablist .hao:nth-child(2) {
  background: url('../../../static/img/nongji1.png') no-repeat 16% center;
  background-size: 21px;
}
.tablist .hao:nth-child(2).activeSubsidy {
  background: url('../../../static/img/kuaqu-icon.png')no-repeat 16% center;
  background-size: 21px;
}
.tablist .hao:nth-child(3) {
  background: url('../../../static/img/nongji2.png') no-repeat 15% center;
  background-size: 24px;
  /* border-right: none; */
}
.tablist .hao:nth-child(3).activeSubsidy {
  background: url('../../../static/img/data_njyj0.png')no-repeat 15% center;
  background-size: 21px;
}
.tablist .hao:nth-child(4) {
  background: url('../../../static/img/nongji3.png') no-repeat 15% center;
  background-size: 24px;
}
.tablist .hao:nth-child(4).activeSubsidy {
  background: url('../../../static/img/tongji-lan.png')no-repeat 15% center;
  background-size: 21px;
}
.hao:nth-child(4){
  border-right: none;
  padding-left: 72px;
}
.hao.activeSubsidy {
  color: #ffffff;
  font-weight: bold;
}
.nav {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  height: 5vw;
  line-height: 5vw;
  width: 23%;
}
.tablist img {
  width: 1.3vw;
  height: 1.1vw;
  vertical-align: middle;
  padding-bottom: 0.3vw;
}
.tablist span {
  /* color: #c0d6ff; */
  font-size: 1vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Subsidies/nav.vue